import { render, staticRenderFns } from "./newleave.vue?vue&type=template&id=7cc82575&scoped=true"
import script from "./newleave.vue?vue&type=script&lang=js"
export * from "./newleave.vue?vue&type=script&lang=js"
import style0 from "./newleave.vue?vue&type=style&index=0&id=7cc82575&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc82575",
  null
  
)

export default component.exports